"use strict";
// (C) 2007-2019 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertExecutionToJson = void 0;
/**
 * Converts 'client-land' AFM to JSON payload acceptable by REST API.
 *
 * @param execution - execution to send to API
 */
function convertExecutionToJson(execution) {
    return JSON.stringify(execution);
}
exports.convertExecutionToJson = convertExecutionToJson;
//# sourceMappingURL=execute-afm.convert.js.map